import React, { useEffect } from 'react';
import { Toast } from '../../ui';
import { PickerComponent } from '../../../hooks/useCreditsPicker';
import { Step2CreditGate } from '../../../hooks/useStep2CreditGate';
import ConnectedCreditsPicker from './ConnectedCreditsPicker';

/**
 * What Step 2 shows on entry when the balance cannot cover every line: the
 * gate picker, open before the buyer can touch anything (the step's own form
 * is inert behind it), and, once they have kept their lines, Robbie's one-line
 * confirmation. Renders nothing when the balance covers the BOM.
 */
export interface CreditGateProps {
  state: Step2CreditGate;
  components: PickerComponent[];
  /** Display RFQ id for the credit request, e.g. RFQ-003. */
  rfqLabel?: string;
  /** "Back to upload". */
  onBack: () => void;
}

const NOTICE_MS = 5000;

export const CreditGate: React.FC<CreditGateProps> = ({ state, components, rfqLabel, onBack }) => {
  const { gate, notice, dismissNotice } = state;

  useEffect(() => {
    if (!notice) return;
    const timer = setTimeout(dismissNotice, NOTICE_MS);
    return () => clearTimeout(timer);
  }, [notice, dismissNotice]);

  return (
    <>
      {/* Remounted after a changed BOM (`round`), so the pick starts clean. */}
      {gate.needed && (
        <ConnectedCreditsPicker
          key={state.round}
          open
          variant="gate"
          refusal={gate.refusal}
          components={components}
          paidComponentIds={gate.paidIds}
          rfqLabel={rfqLabel}
          starting={state.keeping}
          error={state.error}
          onStart={state.keep}
          onBack={onBack}
        />
      )}
      {notice && !gate.needed && (
        <div className="fixed bottom-s7 right-s7 z-50 max-md:left-s5 max-md:right-s5">
          <Toast status="success" title={notice.title} message={notice.message} onDismiss={dismissNotice} className="max-md:w-full" />
        </div>
      )}
    </>
  );
};

export default CreditGate;
